import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=66f98ce6&scoped=true"
import script from "./secondStep.vue?vue&type=script&lang=js"
export * from "./secondStep.vue?vue&type=script&lang=js"
import style0 from "./secondStep.vue?vue&type=style&index=0&id=66f98ce6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f98ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f98ce6')) {
      api.createRecord('66f98ce6', component.options)
    } else {
      api.reload('66f98ce6', component.options)
    }
    module.hot.accept("./secondStep.vue?vue&type=template&id=66f98ce6&scoped=true", function () {
      api.rerender('66f98ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformActivity/components/secondStep.vue"
export default component.exports